import bender from 'quartz-bender-project-dep-and-path-variables-loader!';
window.hubspot = window.hubspot || {};
// @ts-ignore legacy property
window.hubspot.bender = bender;